import React from 'react'
import PropTypes from 'prop-types'

const LandingScreeningCTA = ({ block, onButtonClick, onLoginClick }) => {
  const { className, title } = block
  return (
    <div className={`row text-center align-items-center justify-content-center py-4 py-lg-5 ${className}`}>
      <div className='col-12 col-md-10 col-lg-6 col-xl-5 my-3 mb-3 mb-lg-5 px-5 px-lg-0'>
        <div className='pt-2 pt-lg-4 px-3 px-lg-0'>
          <h2 className='mb-4' data-cy='landing-screening-title'>{title}</h2>
        </div>
        <div className='px-3 py-4 py-lg-2'>
          <button className='btn btn-primary btn-sm-block mx-2 mb-3' data-cy='begin-screen' onClick={onButtonClick}>Begin Screening</button>
        </div>
        <div className='px-3'>
          Already applied? <span className='text-primary pointer' data-cy='check-status' onClick={onLoginClick}>Check the status of your application.</span>
        </div>
      </div>
    </div>
  )
}

LandingScreeningCTA.propTypes = {
  onButtonClick: PropTypes.func,
  onLoginClick: PropTypes.func,
  block: PropTypes.object
}

export default LandingScreeningCTA
